import { api as translateApi } from './auto-generated/translate'

translateApi.enhanceEndpoints({
  endpoints: {},
})

export { translateApi }
